import React  from 'react'
import './styles.sass'
import {useHistory} from 'react-router-dom'

export function HeaderCaja(props){
    const {
        rute,
        title = ""
    } = props
    const history = useHistory()

    function returnHistory(){
        history.goBack()
    }

    return(
        <header className="caja">
			<span className="logoClaroshop"></span>
            <div className="container">
                <div className="header-caja">
                    <ul className="path">
                        <li className={rute === "direccion" ? "active" : null}> Dirección </li>
                        <li className={rute === "pago" ? "active" : null}> Pago </li>
                        <li className={rute === "confirmacion" ? "active" : null}> Confirmación </li>
                    </ul>
                </div>
            </div>
            <div className="container titleBar">
                <div onClick={returnHistory} className="btnReturn">Regresar</div>
                <h2 className="titleHeader">{title}</h2>
            </div>
		</header>
    )
}